import Image, { type ImageProps } from "next/image";
import { getSeasonImage } from "@/lib/season-skin";

type SeasonalImageProps = Omit<ImageProps, "src"> & {
  /** 기본 이미지 경로. 시즌 이미지는 `lib/season-skin.ts` 교체표에서 찾는다 */
  src: string;
};

/**
 * 시즌 스킨 대응 이미지 (JCG-3694).
 *
 * 교체표에 `src` 가 있으면 기본·시즌 이미지를 함께 두고 `season:` variant 로 하나만 보인다 —
 * 사용자가 스킨을 끄면 새로고침 없이 기본 이미지로 돌아간다. 래퍼는 `display: contents` 라 레이아웃에
 * 끼지 않으므로 이미지 className 은 그대로 쓰면 된다. 교체표에 없거나 스위치가 꺼져 있으면 일반 `next/image` 다.
 */
export default function SeasonalImage({
  alt,
  priority,
  ...props
}: SeasonalImageProps) {
  const season = getSeasonImage(props.src);
  if (!season) return <Image alt={alt} priority={priority} {...props} />;

  // 시즌 중엔 대부분 시즌 이미지를 보므로 우선 로딩은 시즌 쪽에만 준다.
  // 기본 쪽은 lazy 로 두어 숨어 있는 동안 받지 않고, 스킨을 끈 사람만 받는다.
  return (
    <>
      <span className="contents season:hidden">
        <Image alt={alt} {...props} />
      </span>
      <span className="hidden season:contents">
        <Image
          {...props}
          src={season.src}
          alt={season.alt ?? alt}
          priority={priority}
        />
      </span>
    </>
  );
}
